import ReactQuill, { ReactQuillProps } from "react-quill";
import QuillEditor, {
  EditorContainer,
} from "components/atoms/input/editor/QuillEditor";
import { useEffect, useMemo, useRef } from "react";
import styled from "styled-components";

interface NoticeEditorProp extends ReactQuillProps {
  isDisabledInput: boolean;
}

function NoticeEditor(props: NoticeEditorProp): JSX.Element {
  const modules = useMemo(
    () => ({
      toolbar: {
        // container에 등록되는 순서대로 tool 배치
        container: [
          ["link"], // 굵기, 기울기, 밑줄 등 부가 tool 설정
        ],
        handlers: {
          link: function (value: string) {
            const that: any = this;

            const tooltip = that.quill.theme.tooltip;
            const input = tooltip.root.querySelector("input[data-link]");
            input.dataset.link = "https://digital-watchdog.com/";
            input.placeholder = "https://digital-watchdog.com/";
            input.dataset.lpignore = true;

            // https://github.com/quilljs/quill/blob/develop/themes/snow.js#L113
            if (value) {
              const range = that.quill.getSelection();
              if (range == null || range.length === 0) {
                return;
              }
              let preview = that.quill.getText(range);
              if (
                /^\S+@\S+\.\S+$/.test(preview) &&
                preview.indexOf("mailto:") !== 0
              ) {
                preview = `mailto:${preview}`;
              }
              const { tooltip } = that.quill.theme;
              tooltip.edit("link", preview);
            } else {
              that.quill.format("link", false);
            }
          },
        },
      },
      keyboard: {
        bindings: {
          // Enter 키 입력 막기
          // handleEnter: {
          //   key: "Enter",
          //   handler: () => {
          //     return false;
          //   },
          // },
          // handleShiftEnter: {
          //   key: 13,
          //   shiftKey: true,
          //   handler: () => {
          //     return false;
          //   },
          // },
        },
      },
    }),
    []
  );

  const formats = ["link"]; // 링크만 허용

  const ref = useRef<ReactQuill>(null);

  useEffect(() => {}, [props.isDisabledInput]);

  return (
    <Wrapper>
      <ReactQuill
        ref={ref}
        modules={modules}
        formats={formats}
        placeholder="Please enter a message"
        onKeyUp={() => ref.current?.getEditor().getSelection()}
        {...props}
      />
    </Wrapper>
  );
}

export default NoticeEditor;

export const Wrapper = styled(EditorContainer)`
  .ql-tooltip.ql-editing {
    left: 0 !important;
  }
`;
